import React from "react"
import Header from "../components/Header"
import Footer from "../components/Footer"
import { useCurrentLang } from "../hooks/useCurrentLang"
import  { contactPageContent }  from "../data/contactPageContent"
import GlassCard from "../components/GlassCard"
import image from "../images/white-logo.png"
export const ContactPage = ({lang="en"}) => {
    const currentLang = useCurrentLang()
    const t = contactPageContent[currentLang]
    return(
        <div className="page page--about">
            <Header lang={currentLang}/>
            <main>
                <section className="page-section page-section--about-main">
                    <div className="content-narrow about-layout about-layout--balanced" >

                    <GlassCard style={{minWidth: "500px"}}>
                        <h2>{t.title}</h2>
                    <div style={{alignItems: "center", display: "flex", justifyContent: "left"}}>
                    <div
                    style={{
                        width: 88,
                        height: 88,
                        borderRadius: "999px",
                        backgroundColor: "#176B87",
                        color: "white",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: 30,
                        fontWeight: 700,
                    }}
                    >
                    <img src={image}  style={{maxHeight: "80px", maxWidth: "80px"}} />
                    </div>
                        <ul className="about-stats" style={{justifyContent: "space-between", marginLeft: "5rem"}}>
                            <li style={{gap: "8rem"}}>
                            <span className="label">{t.contact.name}</span>
                            <span className="value">2026</span>
                            </li>
                            <li>
                            <span className="label">{t.contact.email}</span>
                            <span typeof="email" className="value"><a href="mailto:info@revimo.eu">info@revimo.eu</a></span>
                            </li>
                            <li>
                            <span className="label">{t.contact.location}</span>
                            <span className="value">{t.contact.locationACC}</span>
                            </li>
                        </ul>
                    </div>
                    </GlassCard>
                    
                    </div>
                    </section>
            </main>
            <Footer lang={currentLang}/>
        </div>
    );
};